import styles from 'src/_metronic/assets/sass/core/components/_variables.scss'

const chartOptions = {
  chart: {
    type: 'radialBar',
    offsetY: -10,
    sparkline: {
      enabled: true,
    },
  },
  plotOptions: {
    radialBar: {
      startAngle: -90,
      endAngle: 90,
      track: {
        background: '#e7e7e7',
        strokeWidth: '97%',
        margin: 10,
      },
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          offsetY: 0,
          fontSize: '24px',
          fontWeight: '900',
        },
      },
    },
  },
  grid: {
    padding: {
      top: -10,
    },
  },
  fill: {
    colors: ['#e84200'],
  },
  labels: ['Average Results'],
}

export {chartOptions}
